import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, Subject, ReplaySubject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Booking } from '../models/booking.model';
import { List } from '../models/list.model';
import { environment } from '../../../environments/environment';

enum View {
    Active = 'active',
    Archive = 'archive'
}

@Injectable({
  providedIn: 'root'
})
export class MyBookingsService {

  //pass data to child routes
  private bookingSub$:Subject<Booking> = new ReplaySubject<Booking>(1);
  
  booking$ = this.bookingSub$.asObservable();

  addBooking( booking: Booking ) {
    this.bookingSub$.next( booking );
  }

  constructor( private http: HttpClient ) { }

  getActiveBookings$( userId: string ): Observable<List> {
    return this.getUserBookings$( userId, View.Active );
  }

  getArchiveBookings$( userId: string ): Observable<List> {
    return this.getUserBookings$( userId, View.Archive );
  }

  getUserBookings$( userId: string, view = View.Active ): Observable<List> {

    const responseToList = ( response ): List => {

      let list = new List( { 
        'totalCount': response.totalCount
       } );

      if ( response._embedded && response._embedded.booking ) {
        
        list.items = response._embedded.booking.map(
          bookingApiJson => new Booking( bookingApiJson )
        )
        
      } 

      return list;

    };

    const url = environment.apiUrl + '/users/' + 
      userId + '/bookings?view=' + view + 
      '&expand=provider,bookingselectionitems&pageSize=100&sortBy=start&sortOrder=' +  
      (( view === View.Active ) ? 'asc': 'desc');

    return this.http.get( url ).pipe(
      map( responseToList )
    );

  }

  getBooking$( userId: string, bookingId: string ) {

    const url = environment.apiUrl + '/users/' + 
      userId + '/bookings/' + bookingId + '?expand=provider,bookingselectionitems,bookingproducts';

    return this.http.get( url ).pipe(
      map( ( responseApiJson ) => new Booking( responseApiJson ) ),
      tap( ( booking: Booking ) => this.addBooking( booking ) )
    );
  }


  cancelBooking( booking: Booking ) {
    return this.http.patch( booking._self, { 'canceled': true } );
  }


}
